<template>
  <div class="col-12">
    <slot />
  </div>
</template>
